<template>
  <!-- Histórico de documentos -->
  <v-dialog v-model="dialogframeboton" persistent max-width="1200px">
    <v-toolbar dark color="red-darken-4">
      <v-toolbar-title
        ><v-icon left>mdi-eye-settings-outline</v-icon>
        Visualizar archivo
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn
          class="d-none d-md-block"
          dark
          text
          @click="
            dialogframeboton = false;
            LinkDocumento = null;
            NombreDocumento = null;
            Formato = null;
          "
          >Cerrar</v-btn
        >
      </v-toolbar-items>
    </v-toolbar>
    <card-visores
      v-if="LinkDocumento != null"
      :LinkDocumento="LinkDocumento"
      :NombreDocumento="NombreDocumento"
      :Formato="Formato"
    ></card-visores>
  </v-dialog>
  <v-data-table
    :headers="headers"
    :items="desserts"
    :search="search"
    item-value="name"
    class="elevation-1"
    density="compact"
    height="500"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-inner-icon="mdi-magnify"
          label="Buscar..."
          single-line
          variant="underlined"
          hide-details
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.Nombre="{ item }">
      <div>
        {{ item.raw.Nombre + "-" + item.raw.Formato }}
      </div>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-tooltip location="bottom" color="white">
        <template v-slot:activator="{ props }">
          <v-icon
            @click="RutaDocumento(item.raw)"
            color="red-darken-4"
            v-bind="props"
            >mdi-eye</v-icon
          >
        </template>
        <span>Ver Archivo</span>
      </v-tooltip>
    </template>
  </v-data-table>
  <div class="d-flex align-center flex-column">
    <!-- Linea de progreso -->
    <v-dialog v-model="progreso" persistent width="auto">
      <v-card color="red-darken-4">
        <v-card-text>
          Espera un momento...
          <v-toolbar align="center" color="red-darken-4">
            <v-img
              class="mx-auto"
              :width="5"
              src="/static/iconos/logo2.png"
            ></v-img>
          </v-toolbar>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import visores from "@/views/TCI/Documentos/DocumentosComponents/Visores/Visores.vue";
export default {
  name: "Auditoria",
  components: {
    "card-visores": visores,
  },
  props: {
    ConsulaDocumento: {
      type: Object,
      default: null,
      Description: "Vector de Consulta de docuemntos",
    },
  },
  data() {
    return {
      search: "",
      progreso: false,
      dialogframeboton: false,
      LinkDocumento: null,
      NombreDocumento: null,
      Formato: null,
      headers: [
        {
          title: "Ver Archivo",
          align: "center",
          key: "actions",
        },
        {
          title: "Version",
          align: "start",
          key: "Version",
        },
        {
          title: "Formato",
          align: "start",
          key: "Formato",
        },
        {
          title: "Tamaño (kb)",
          align: "start",
          key: "Tamanio",
        },
        {
          title: "Fecha Vencimiento",
          align: "start",
          key: "FechaVencimiento",
        },
        {
          title: "Usuario Creación",
          align: "start",
          key: "NombreUsuario",
        },
        {
          title: "Fecha Creación",
          align: "start",
          key: "FechaCreacion",
        },
      ],
      desserts: this.ConsulaDocumento,
    };
  },
  methods: {
    ///////////////////////////////////////////////// Métodos de consulta ///////////////////////////////////////////
    RutaDocumento(data) {      
      this.LinkDocumento = null;
      this.NombreDocumento = null;
      this.Formato = null;
      this.LinkDocumento = data.RutaLink;
      this.NombreDocumento = data.Nombre;
      this.Formato = data.Formato;
      this.progreso = true;
      console.log("Entro")
      // Consult Archivo
      this.axios
        .get(
          "/archivosdocumentos/ArchivoEspecifico?rutaComplementaria=" +
            data.RutaFisica +
            "&nombreArchivo=" +
            this.NombreDocumento
        )
        .then((response) => {
          this.LinkDocumento = response.data;
          this.dialogframeboton = true;
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.progreso = false;
        });
    },
    ///////////////////////////////////////////////// Métodos de acciones //////////////////////////////////////////
  },
};
</script>
